<template>
  <p>
    <span class="d-inline-block text-center countdown-item white rounded-sm text-h6 py-1 px-2 light-grey--text">{{ remainingTime.hours }}</span>
    <span class="mx-1 white--text">:</span>
    <span class="d-inline-block text-center countdown-item white rounded-sm text-h6 py-1 px-2 light-grey--text">{{ remainingTime.minutes }}</span>
    <span class="mx-1 white--text">:</span>
    <span class="d-inline-block text-center countdown-item white rounded-sm text-h6 py-1 px-2 light-grey--text">{{ remainingTime.seconds }}</span>
  </p>
</template>

<script>
import { uiHelper } from '@/utils'

export default {
  props: {
    deadline: {
      required: false,
      default: uiHelper.getTomorrowDate()
    }
  },

  data() {
    return {
      currentTime: ''
    }
  },

  computed: {
    remainingTime() {
      let t = Date.parse(this.deadline) - Date.parse(this.currentTime)
      const remaining = { hours: '00', minutes: '00', seconds: '00' }
      if (t > 0) {
        remaining.hours = uiHelper.padTime(Math.floor(t / 1000 / 60 / 60))
        remaining.minutes = uiHelper.padTime(Math.floor((t / 1000 / 60) % 60))
        remaining.seconds = uiHelper.padTime(Math.floor((t / 1000) % 60))
      }
      return remaining
    }
  },

  methods: {
    countdown() {
      this.currentTime = new Date()
      this.$nextTick(() => {
        const { hours, minutes, seconds } = this.remainingTime
        if (!(parseInt(hours) === 0 && parseInt(minutes) === 0 && parseInt(seconds) === 0)) {
          setTimeout(this.countdown)
        }
      })
    }
  },

  mounted() {
    this.countdown()
  }
}
</script>

<style lang="scss" scoped>
.countdown-item {
  min-width: 2rem;
}
</style>
